export default "__VITE_ASSET__CEgVd_zl__"